import { useMemo, useState } from "react";
import useDocumentTitle from "../../utils/useDocumentTitle";
import PageContent from "../../components/PageContent";
import Section from "../../components/Section";
import SectionTitle from "../../components/SectionTitle";
import DataTable from "../../components/DataTable";
import { DashboardLayout } from "../../layouts/DashboardLayout";
import PiiAdminService from "../../services/PiiAdminService";
import styles from "./PiiAdmin.module.scss";

const STAGE_OPTIONS = ["preparation", "coaching_session", "conversational"];

const columns = [
  { id: "session_id", label: "Session ID", sortable: false },
  { id: "stage", label: "Stage", sortable: false },
  { id: "field_reference", label: "Field Reference", sortable: false },
  {
    id: "detection_types",
    label: "Detection Types",
    sortable: false,
    render: val => (Array.isArray(val) ? val.join(", ") : val),
  },
  {
    id: "overridden",
    label: "Overridden",
    sortable: false,
    render: val => (val ? "Yes" : "No"),
  },
  {
    id: "override_reason",
    label: "Override Reason",
    sortable: false,
    render: val => val || "—",
  },
  {
    id: "last_event_at",
    label: "Last Event At",
    sortable: false,
    render: val => (val ? new Date(val).toLocaleString() : "—"),
  },
];

function renderExpandedContent(row) {
  const events = Array.isArray(row.events) ? row.events : [];
  if (!events.length) return <div>No event history</div>;

  return (
    <ul className={styles.eventList}>
      {events.map((event, index) => (
        <li key={index}>
          {event.occurredAt ? new Date(event.occurredAt).toLocaleString() : "—"}
          {" — "}
          {event.stage} / {event.fieldReference} — {(event.detectionTypes || []).join(", ")}
          {event.overridden ? ` (overridden: ${event.overrideReason || "—"})` : ""}
        </li>
      ))}
    </ul>
  );
}

export function PiiDetectionLogs(props) {
  useDocumentTitle(props.title);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [stage, setStage] = useState("");

  const filters = useMemo(
    () => ({
      startDate: startDate || undefined,
      endDate: endDate || undefined,
      stage: stage || undefined,
    }),
    [startDate, endDate, stage]
  );

  return (
    <DashboardLayout isDisableCampaignSelection={true}>
      <PageContent>
        <Section>
          <SectionTitle>PII Detection Logs</SectionTitle>

          <div className={styles.filterBar}>
            <label>
              Start date
              <input
                type="date"
                value={startDate}
                onChange={e => setStartDate(e.target.value)}
              />
            </label>
            <label>
              End date
              <input
                type="date"
                value={endDate}
                onChange={e => setEndDate(e.target.value)}
              />
            </label>
            <label>
              Stage
              <select value={stage} onChange={e => setStage(e.target.value)}>
                <option value="">All</option>
                {STAGE_OPTIONS.map(option => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </label>
          </div>

          <DataTable
            columns={columns}
            fetchData={PiiAdminService.getDetectionLogs}
            filters={filters}
            defaultOrderBy="last_event_at"
            defaultOrder="desc"
            expandable
            renderExpandedContent={renderExpandedContent}
            storageKey="piiDetectionLogs"
          />
        </Section>
      </PageContent>
    </DashboardLayout>
  );
}
